module.exports = __webpack_public_path__ + "img/Vector 8.b07d498b.svg";